import { useMediaQuery } from 'react-responsive';
import { MediaQueryTablet } from '@/Constants';

interface UseStackedTableLayout {
  customQuery?: string;
}

function useStackedTableLayout({ customQuery }: UseStackedTableLayout = {}) {
  return useMediaQuery({ query: customQuery || MediaQueryTablet });
}

export { useStackedTableLayout };
